import { createContext, useContext, useEffect, useState } from "react";
import fr from "./content.fr";
import en from "./content.en";
import ar from "./content.ar";

// Ajouter une langue : importer le fichier ici et l'inscrire dans `contents` (+ LANGS).
const contents = { fr, en, ar };
export const LANGS = [
  { code: "fr", label: "FR", name: "Français" },
  { code: "en", label: "EN", name: "English" },
  { code: "ar", label: "عربي", name: "العربية" },
];
const RTL = ["ar"];

// 1) choix manuel mémorisé, 2) langue du navigateur (fr, en ou ar), 3) français par défaut.
const detect = () => {
  try {
    const saved = localStorage.getItem("cba-lang");
    if (saved && contents[saved]) return saved;
  } catch (e) { /* stockage bloqué */ }
  const prefs = (typeof navigator !== "undefined" && (navigator.languages?.length ? navigator.languages : [navigator.language])) || [];
  for (const p of prefs) {
    const code = String(p || "").slice(0, 2).toLowerCase();
    if (contents[code]) return code;
  }
  return "fr";
};

const Ctx = createContext({ content: fr, lang: "fr", setLang: () => {} });

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(detect);
  const setLang = (l) => {
    try { localStorage.setItem("cba-lang", l); } catch (e) { /* stockage bloqué */ }
    setLangState(l);
  };
  useEffect(() => {
    const root = document.documentElement;
    root.lang = lang;
    root.dir = RTL.includes(lang) ? "rtl" : "ltr";
  }, [lang]);
  return <Ctx.Provider value={{ content: contents[lang] || fr, lang, setLang, fr }}>{children}</Ctx.Provider>;
};

export const useLang = () => useContext(Ctx);
export const useContent = () => useContext(Ctx).content;
